import './config'
import { useTranslation } from 'react-i18next'

export const useLocalization = () => {
  const { t } = useTranslation(['common'])

  return t
}
